import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';  // ← change this
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />  {/* ← and this */}
  </React.StrictMode>
);

reportWebVitals();